module.exports = __webpack_public_path__ + "static/img/1365_phase_function_Paper_Points.c67415e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1365_phase_function_Paper_Points.png
// module id = rQxK
// module chunks = 0